import { render, staticRenderFns } from "./changeManagement.vue?vue&type=template&id=2c528baa&scoped=true&"
import script from "./changeManagement.vue?vue&type=script&lang=js&"
export * from "./changeManagement.vue?vue&type=script&lang=js&"
import style0 from "./changeManagement.vue?vue&type=style&index=0&id=2c528baa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c528baa",
  null
  
)

export default component.exports